export const staticProjectIdsSC = '41';

export const person = 'ท่าน';
